import { render, staticRenderFns } from "./AlertsWidget.vue?vue&type=template&id=6fe27007&"
import script from "./AlertsWidget.vue?vue&type=script&lang=js&"
export * from "./AlertsWidget.vue?vue&type=script&lang=js&"
import style0 from "./AlertsWidget.vue?vue&type=style&index=0&id=6fe27007&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports